// Преобразует отображаемое значение в значение фильтра (добавляет 0.1 для включения предложений с небольшими вариациями)
export const getDownPaymentFilterValue = (displayValue: string | number): number => {
  return Number(displayValue) + 0.1;
};
